var map = {
	"./体检01.png": 2967,
	"./体检02.png": 2968,
	"./体检03.png": 2969,
	"./体检04.png": 2970,
	"./体检05.png": 2971,
	"./体检默认.png": 2972,
	"./卡01.png": 2973,
	"./卡02.png": 2974,
	"./卡03.png": 2975,
	"./卡04.png": 2976,
	"./卡05.png": 2977,
	"./卡默认.png": 2978,
	"./宿舍01.png": 2979,
	"./宿舍02.png": 2980,
	"./宿舍03.png": 2981,
	"./宿舍04.png": 2982,
	"./宿舍05.png": 2983,
	"./宿舍默认.png": 2984,
	"./打印01.png": 2985,
	"./打印02.png": 2986,
	"./打印03.png": 2987,
	"./打印04.png": 2988,
	"./打印05.png": 2989,
	"./打印默认.png": 2990,
	"./报到01.png": 2991,
	"./报到02.png": 2992,
	"./报到03.png": 2993,
	"./报到04.png": 2994,
	"./报到05.png": 2995,
	"./报到默认.png": 2996,
	"./校服01.png": 2997,
	"./校服02.png": 2998,
	"./校服03.png": 2999,
	"./校服04.png": 3000,
	"./校服05.png": 3001,
	"./校服默认.png": 3002,
	"./缴费01.png": 3003,
	"./缴费02.png": 3004,
	"./缴费03.png": 3005,
	"./缴费04.png": 3006,
	"./缴费05.png": 3007,
	"./缴费默认.png": 3008,
	"./通用01.png": 3009,
	"./通用02.png": 3010,
	"./通道01.png": 3011,
	"./通道02.png": 3012,
	"./通道03.png": 3013,
	"./通道04.png": 3014,
	"./通道05.png": 3015,
	"./通道默认.png": 3016
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3060;


//////////////////
// WEBPACK FOOTER
// ./styles/images/user/normal (\.gif|\.jpeg|\.png|\.jpg|\.bmp)
// module id = 3060
// module chunks = 0